/**
 * Who may hold and change a demand's assignee (FR-5.20, HS2-C63T9N), shared by the server routes
 * and the client's Info control and row menu so both apply the same rule.
 */

/** The staff roles: a member holding any of them may be assigned a demand and may assign one. */
export const ASSIGNABLE_ROLES = ['procurement', 'reviewer', 'admin'] as const;

/** Whether these roles make a member staff (assignable, and allowed to change assignees). */
export function isAssignableRoles(roles: readonly string[]): boolean {
  return roles.some((role) => (ASSIGNABLE_ROLES as readonly string[]).includes(role));
}
